const Epochs = {
  pd: 'pd',
  f2040: '2040s'
};

const EpochOptions = [
  {key: 1, value: Epochs.pd, text: 'Present Day'},
  {key: 2, value: Epochs.f2040, text: Epochs.f2040}
]

const RPs = {
  fluvial: [1,2,5,10,20, 50,100,200,500,1000,2000,5000,10000],
  sw: [10,100,1000]
};

const HazardTypes = {
  chirpsRainfall: 'Rainfall',
  fluvial: 'Fluvial',
  surfaceWater: 'Surface water',
};

const ClimateFutures = {
  none: 'NONE',
  low: 'LOW',
  high: 'HIGH'
};


export {
  ClimateFutures,
  Epochs,
  EpochOptions,
  HazardTypes,
  RPs
};